import { Component, Input, OnInit } from '@angular/core';
import { ProjectListService } from 'src/app/modules/home/services/project-list.service';
import { IDistribution, ILookup } from 'src/app/shared/models/app.model';

@Component({
  selector: 'distribution-grid',
  templateUrl: './distribution-grid.html',
  styleUrls: ['./distribution-grid.less'],
})
export class DistributionGrid implements OnInit {
  @Input() sendReportStatus: number = 1;
  ACTION = {
    APPROVE: 'Approve',
    DECLINE: 'Decline',
    AUDIT: 'Audit',
    DISTRIBUTE: 'Distribute',
    REGENERATE_REPORT: 'Regenerate Report',
  };
  status_action_map: any[] = [
    [],
    [this.ACTION.APPROVE, this.ACTION.DECLINE, this.ACTION.AUDIT],
    [this.ACTION.DISTRIBUTE, this.ACTION.AUDIT],
    [this.ACTION.REGENERATE_REPORT, this.ACTION.AUDIT],
    [this.ACTION.AUDIT],
  ];
  lookup: ILookup = {
    status: [],
    studios: [],
    productionTypes: [],
    corporations: [],
    distributors: [],
    creativeExecutives: [],
		category: [],
  };
  distributionList: IDistribution[] = [
    {
      id: 1,
      weekEndingDate: new Date(),
      reportGenerationDate: new Date(),
      requestorForApproval: 1,
      approvalWorkflow: [1, 3],
      approvedBy: [],
      declineBy: [],
      pendingWith: [1, 3],
      distributionUser: [4],
      status: 1,
      remarks: '',
    },
  ];
  constructor(private projectListService: ProjectListService) {

    this.projectListService.getLookup().subscribe((resp) => {
      this.lookup = resp;
    });
    this.projectListService.getDistributionList().subscribe((resp) => {
      this.distributionList = resp.distributionList;
    });
  }
  ngOnInit(): void {}
  psrReviewPopupVisible: boolean = false;
  psrReviewPopup = (e: any, data: any) => {
    this.weekendingDate = data.weekEndingDate || '';
    this.productionStatus = data.productionStatus || '';
    this.productionStudio = data.productionStudio || '';
    this.selectedTitles = data.selectedTitles || '';
    this.psrReviewPopupVisible = true;
    this.sendReportStatus = 1;
  };
  hidePopup = (e: any) => {
    this.psrReviewPopupVisible = false;
  };
  fileName = 'PSR';
  cellTemplate = (container: any, options: any) => {
    const noBreakSpace = '\u00A0';
    const text: string[] = [];
    const textHTML = (options.value || [])
      .map((element: any) => {
        let userName = options.column.lookup.calculateCellValue(element);
        text.push(userName);
        let approveIconHTML =
          ' <span title="' +
          this.ACTION.APPROVE +
          '" class="fa fa-check-circle text-success"></span>';
        let declineIconHTML =
          ' <span title="' +
          this.ACTION.DECLINE +
          '" class="fa fa-times-circle text-danger"></span>';
        let pendingIconHTML =
          ' <span title="Pending" class="fa fa-minus-circle text-warn"></span>';
        let iconHTML = '';
        if (options.data.approvedBy.includes(element)) {
          iconHTML = approveIconHTML;
        } else if (options.data.declineBy.includes(element)) {
          iconHTML = declineIconHTML;
        } else if (options.data.pendingWith.includes(element)) {
          iconHTML = pendingIconHTML;
        }
        return '<span class="userName">' + userName + iconHTML + '</span>';
      })
      .join(' \n');
    container.innerHTML = textHTML;
    // container.textContent = text || noBreakSpace;
    container.title = text.join(', \n');
  };
  cellTemplate2 = (container: any, options: any) => {
    const noBreakSpace = '\u00A0';
    const text = (options.value || [])
      .map((element: any) => options.column.lookup.calculateCellValue(element))
      .join(', \n');
    container.textContent = text || noBreakSpace;
    container.title = text;
  };
  calculateFilterExpression = (
    filterValue: any,
    selectedFilterOperation: any,
    target: any
  ) => {
    if (target === 'search' && typeof filterValue === 'string') {
      return [(this as any).dataField, 'contains', filterValue];
    }
    return function (data: any) {
      return (data.corporations || []).indexOf(filterValue) !== -1;
    };
  };
  weekendingDate = new Date();
  productionStatus = '';
  productionStudio = '';
  selectedTitles = '';
}
